
import { Options, Vue, prop } from "vue-class-component";
import { ClaimController } from "@/app/ui/controllers/ClaimController";

class Prop {
  isDisabled = prop<boolean>({
    type: Boolean,
    default: false
  });
}

@Options({
  emits: ["opened", "openFilterPopUp"],
  components: {}
})
export default class AdvanceFilter extends Vue.with(Prop) {
  isScreenMD = true;
  isChevron = false;
  openFilter = false;

  mounted() {
    this.checkScreenSize()
    window.addEventListener('resize', this.checkScreenSize)
  }

  checkScreenSize() {
    // Cek ukuran layar saat ini
    if (window.innerWidth >= 768) {
      // Jika layar lebih besar dari 768px (breakpoint md di Tailwind)
      this.isScreenMD = true;
    } else {
      // Jika layar lebih kecil dari 768px
      this.isScreenMD = false;
    }
  }

  resetFilter() {
    this.statusValue = "";
    this.categoryValue = "";

    ClaimController.onSelectStatus("");
    ClaimController.onSelectCategory("");
  }

  get sumFilter() {
    return (
      (this.statusValue !== "" ? 1 : 0) + (this.categoryValue !== "" ? 1 : 0)
    );
  }

  // filter status
  statusSelect = false;
  onOpenStatusSelect() {
    this.statusSelect = true;
  }
  onCloseStatusSelect() {
    this.statusSelect = false;
  }

  get statusValue() {
    return ClaimController.status;
  }
  set statusValue(newValue: string) {
    ClaimController.onSelectStatus(newValue);
  }
  onSelectStatus(name: string, value: string) {
    this.onCloseStatusSelect();
    this.statusValue = value;
  }
  get statusData() {
    return [
      {
        name: this.$t("claim.filter.selectStatusClaim"),
        value: ""
      },
      {
        name: this.$t("claim.submitted"),
        value: "submitted"
      },
      {
        name: this.$t("claim.approved"),
        value: "approved"
      },
      {
        name: this.$t("claim.rejected"),
        value: "rejected"
      },
      {
        name: this.$t("claim.finished"),
        value: "finished"
      }
    ];
  }

  // filter category
  categorySelect = false;
  onOpenCategorySelect() {
    this.categorySelect = true;
  }
  onCloseCategorySelect() {
    this.categorySelect = false;
  }

  onSelectCategory(name: string, value: string) {
    this.onCloseCategorySelect();
    this.categoryValue = value;
  }

  get categoryValue() {
    return ClaimController.category;
  }
  set categoryValue(newValue: string) {
    ClaimController.onSelectCategory(newValue);
  }
  get categoryData() {
    return [
      {
        name: this.$t("claim.filter.selectCategory"),
        value: ""
      },
      {
        name: this.$t("claim.missing"),
        value: "lost"
      },
      {
        name: this.$t("claim.damaged"),
        value: "damaged"
      },
      {
        name: this.$t("claim.overdue"),
        value: "mbg"
      }
    ];
  }
}
